import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { BrMaskerModule } from 'br-mask';
import { TranslateModule } from '@ngx-translate/core';
import { MenuComponent } from './menu/menu.component';
import { HeadbarComponent } from './headbar/headbar.component';
import { WalletCardComponent } from './wallet/wallet-card/wallet-card.component';
import { TransactionsComponent } from './extracts/transactions/transactions.component';
import { LoadingComponent } from './loading/loading.component';
import { LoadingSmallComponent } from './loading-small/loading-small.component';
import { ModalSettingsComponent } from './modals/modal-settings/modal-settings.component';
import { ModalChangePasswordComponent } from './modals/modal-change-password/modal-change-password.component';
import { WalletMenuComponent } from './wallet/wallet-menu/wallet-menu.component';
import { ModalHelpDepositComponent } from './modals/modal-help-deposit/modal-help-deposit.component';
import { WithdrawByTransferComponent } from './withdraw/withdraw-by-transfer/withdraw-by-transfer.component';
import { WithdrawByDeliveryComponent } from './withdraw/withdraw-by-delivery/withdraw-by-delivery.component';
import { ExchangeRsComponent } from './exchange/exchange-rs/exchange-rs.component';
import { ExchangeBsComponent } from './exchange/exchange-bs/exchange-bs.component';
import { ExchangeUsComponent } from './exchange/exchange-us/exchange-us.component';
import { AllTransactionsComponent } from './extracts/all-transactions/all-transactions.component';
import { BankAccountComponent } from './bank/bank-account/bank-account.component';
import { FormDebugComponent } from './form-debug/form-debug.component';
import { ModalQrCodeComponent } from './modals/modal-qr-code/modal-qr-code.component';



@NgModule({
  declarations: [
    FormDebugComponent,
    MenuComponent,
    HeadbarComponent,
    WalletCardComponent,
    WalletMenuComponent,
    TransactionsComponent,
    AllTransactionsComponent,
    LoadingComponent,
    LoadingSmallComponent,
    ModalSettingsComponent,
    ModalChangePasswordComponent,
    ModalHelpDepositComponent,
    ModalQrCodeComponent,

    WithdrawByTransferComponent,
    WithdrawByDeliveryComponent,

    ExchangeRsComponent,
    ExchangeBsComponent,
    ExchangeUsComponent,

    BankAccountComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrMaskerModule,
    TranslateModule
  ],
  exports: [
    FormDebugComponent,
    MenuComponent,
    HeadbarComponent,
    WalletCardComponent,
    WalletMenuComponent,
    TransactionsComponent,
    AllTransactionsComponent,
    LoadingComponent,
    LoadingSmallComponent,
    ModalSettingsComponent,
    ModalChangePasswordComponent,
    ModalHelpDepositComponent,
    ModalQrCodeComponent,

    WithdrawByTransferComponent,
    WithdrawByDeliveryComponent,

    ExchangeRsComponent,
    ExchangeBsComponent,
    ExchangeUsComponent,

    BankAccountComponent

  ]
})
export class ComponentsModule { }
